import * as React from 'react';

import styled from '@emotion/styled';
import { Bone } from '@lightspeed/flame/Bone';
import { Box } from '@lightspeed/flame/Core';
import { Heading4 } from '@lightspeed/flame/Text';

import Format from 'helpers/format';
import { useNuorderOrdering } from 'root/apps/PurchaseOrder/NuorderOrdering/context/Context';

const TableStyled = styled.table`
  td {
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }
  td:nth-of-type(even) {
    text-align: right;
  }
`;

export const SummaryCost = () => {
  const {
    state: { purchase },
  } = useNuorderOrdering();

  if (!purchase) {
    return (
      <Box flexBasis="34%" data-test="summary-cost-bones">
        <Bone width={200} height={20} style={{ marginBottom: '1em' }} />
        <Bone width={200} height={20} style={{ marginBottom: '1em' }} />
      </Box>
    );
  }

  return (
    <Box flexBasis="34%" data-test="summary-cost">
      <Heading4 textAlign="center" mb={2}>
        Cost Summary
      </Heading4>
      <TableStyled>
        <tbody>
          {[
            ['Order Subtotal', purchase.subTotalCost || 0],
            ['Shipping Cost', purchase.shipCost || 0],
            ['Other Cost', purchase.otherCost || 0],
            ['Discount', purchase.totalDiscount || 0],
          ].map(([label, value]) => (
            <tr key={label}>
              <td>{label}</td>
              <td data-test={`${label}-money`}>
                <var>{Format.toMoney(value)}</var>
              </td>
            </tr>
          ))}
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          {[['Order Total', purchase.totalCost || 0]].map(([label, value]) => (
            <tr key={label}>
              <td style={{ fontWeight: 700 }}>{label}</td>
              <td data-test={`${label}-money`} style={{ fontWeight: 700 }}>
                <var>{Format.toMoney(value)}</var>
              </td>
            </tr>
          ))}
        </tbody>
      </TableStyled>
    </Box>
  );
};
